import { useDroppable } from "@dnd-kit/core"
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable"
import { Box, Text } from "@mantine/core"
import { Column } from "@tanstack/react-table"

import { ColumnManagerTranslationFallbackKeys } from "../config"

import { ColumnDraggableItem } from "./ColumnDraggableItem"

export type DroppableAreaProps<T> = {
  id: string
  columns: Column<T, unknown>[]
  pinnedColumns?: Column<T, unknown>[]
  title: string
  count: number
  translations: Record<
    keyof typeof ColumnManagerTranslationFallbackKeys,
    string
  >
}

export const DroppableArea = <T,>({
  id,
  columns,
  pinnedColumns = [],
  title,
  count,
  translations,
}: DroppableAreaProps<T>) => {
  const { setNodeRef, isOver } = useDroppable({ id })
  const totalCount = count + pinnedColumns.length

  return (
    <Box>
      <Text fw={600} size="xs" c="dimmed">
        {title} ({totalCount})
      </Text>
      <Box
        ref={setNodeRef}
        mih="50px"
        bg={isOver ? "var(--mantine-color-gray-0)" : "white"}
        p="xs"
      >
        {pinnedColumns.length > 0 || columns.length > 0 ? (
          <>
            {pinnedColumns.map((column) => (
              <ColumnDraggableItem key={column.id} column={column} pinned />
            ))}
            <SortableContext
              items={columns.map((col) => col.id)}
              strategy={verticalListSortingStrategy}
            >
              {columns.map((column) => (
                <ColumnDraggableItem key={column.id} column={column} />
              ))}
            </SortableContext>
          </>
        ) : (
          <Text c="dimmed" ta="center" py="md" size="sm" truncate>
            {translations.noColumnsMatch}
          </Text>
        )}
      </Box>
    </Box>
  )
}
